var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSales4 = function SvgSales4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68.379 60"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M68.379 5.308v12.8H0v-12.8h15.819V0h4.684v12.177h4.684V5.308h22.585V0h4.683v12.177h4.684V5.308Zm0 17.172V60H0V22.48Zm-14.7 26.183h-3.621V36.211h-4.891v.012-5.216h-4.891v5.216h-3.591v-7.3h-4.892v7.3h-3.59v-5.216h-4.892v5.2h-4.892v12.452h-3.724v4.892h38.99Zm-8.512-7.548H23.31v7.548h21.857Z"
  })));
};
export default SvgSales4;